import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "152.969",
  height: "152.969"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "data-name": "Group 3657",
      opacity: ".02"
    }, [
      _createElementVNode("g", { "data-name": "Group 3656" }, [
        _createElementVNode("path", {
          fill: "#1a1818",
          d: "m39.043 128.528 22.624-17.573c8.282 11.311 18.382 16.968 31.713 16.968 16.564 0 25.25-8.485 25.25-20.4 0-12.321-9.292-20.805-24.239-20.805H75.2V63.283h19.191c13.735 0 21.815-7.675 21.815-18.785s-7.878-19.19-22.826-19.19c-13.129 0-22.018 6.06-29.087 15.15L42.68 22.682C53.587 9.552 68.333.261 94.391.261c36.359 0 55.548 17.775 55.548 40.8 0 15.352-8.686 26.663-22.624 32.319v.4c16.564 6.868 25.654 19.19 25.654 35.754 0 24.845-20.806 43.428-58.578 43.428-29.694 0-46.056-11.513-55.348-24.441",
          "data-name": "Path 1811"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }